import { type FC } from 'react';

import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import GroupWorkOutlined from '@mui/icons-material/GroupWorkOutlined';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import SchoolOutlined from '@mui/icons-material/SchoolOutlined';

import { SideNavButton } from '@/src/components/atoms/navButtons';
import { HasFeatureFlag } from '@/src/features/integrations/statsig/components/HasFeatureFlag';

import { NavDivider } from './NavDivider';

export const InstructorNavLinks: FC = () => (
  <>
    <SideNavButton icon={DashboardOutlined} page='dashboard'>
      Dashboard
    </SideNavButton>
    <NavDivider />
    <SideNavButton icon={PeopleOutlined} page='learners'>
      Learners
    </SideNavButton>
    <SideNavButton icon={SchoolOutlined} page='programs'>
      Programs
    </SideNavButton>
    <HasFeatureFlag.SkillsObservationTrackingInstructors>
      <SideNavButton icon={GroupWorkOutlined} page='learner-cohorts'>
        Cohorts
      </SideNavButton>
    </HasFeatureFlag.SkillsObservationTrackingInstructors>
    <NavDivider />
  </>
);
